import React from 'react';
import PropTypes from 'prop-types';

import {Rating, Typography, Stack} from 'views/components';
import {translate} from 'views/module';

const BuildCareview = (props) => {
  const {answers} = props;
  // Convert the answers object to an array.
  const answersArray = Object.values(answers);
  // Sort answers by rankorder if available.
  const answersArraySorted = answersArray.sort((a, b) => a.question.rankorder - b.question.rankorder);

  return (
    <Stack spacing={1}>
      {
        answersArraySorted.map((answerObj, index) => {
          const questionTitle = (answerObj.question.questionData.questionTitle);
          let answerDisplay = null;

          switch (answerObj.question.type) {
            case 'FIVE_STAR': {
              const rating = answerObj.answer.fiveStarReview;
              answerDisplay = <Rating value={rating} readOnly size="small" />;
              break;
            }
            case 'YES_NO': {
              const yn = answerObj.answer.yesNoAnswer.toLowerCase() === 'yes' ? translate('generic.Yes') : translate('generic.No');
              answerDisplay = (
                <Stack spacing={0.5}>
                  <Typography variant="body2" fontSize={'15px'} fontWeight={600}>
                    {yn}
                  </Typography>
                  {
                    answerObj.answer.reason &&
                    <Typography variant="body2" sx={{color: 'inherit', fontWeight: 400, fontSize: '14px', pl: 1}}>
                      {answerObj.answer.reason}
                    </Typography>
                  }
                </Stack>
              );
              break;
            }
            case 'MULTIPLE_CHOICE': {
              const choice = answerObj.answer.selectedOption;
              answerDisplay = (
                <Stack spacing={0.5}>
                  <Typography variant="body2" fontSize={'15px'} fontWeight={600}>
                    {choice}
                  </Typography>
                  {
                    answerObj.answer.reason &&
                    <Typography variant="body2" sx={{color: 'inherit', fontWeight: 400, fontSize: '14px', pl: 1}}>
                      {answerObj.answer.reason}
                    </Typography>
                  }
                </Stack>
              );
              break;
            }
            case 'FREE_FORM_TEXT': {
              const text = answerObj.answer.freeFormAnswer || translate('eventList.EventTimelineSection.ShiftClockedOut.NoAnswer');
              answerDisplay = <Typography variant="body2" fontSize={'15px'} fontWeight={600}>{text}</Typography>;
              break;
            }
          }

          return (
            <Stack key={index} spacing={0.5}>
              <Typography variant="body2" fontWeight="bold" fontSize={'16px'}>
                {questionTitle}
              </Typography>
              <Stack sx={{pl: 1}}>
                {answerDisplay}
              </Stack>
            </Stack>
          );
        })
      }
    </Stack>
  );
};

BuildCareview.propTypes = {
  answers: PropTypes.object.isRequired,
};

export default BuildCareview;
